import React from 'react';
import { Tab } from '../../../common/sharedComponents/Tab';
import { ITabContainer } from '../../../@types/tabContainer';
import {
  TabContainerWrapper,
  TabContainterContent,
  TabsTitle,
  TitleTabsContainer,
  TitleTabsContent,
} from './TabContainer.styled';

export function TabContainer ({
  title,
  tabs,
  handleTabSelection,
  selectedTabIndex = 0,
}: ITabContainer) {
  return (
    <>
      <TitleTabsContainer>
        <TitleTabsContent>
          <TabsTitle ellipsis={true}>{title && title}</TabsTitle>
        </TitleTabsContent>
      </TitleTabsContainer>
      <TabContainerWrapper>
        {tabs &&
          tabs.map((tab, index) => (
            <Tab
              key={index}
              title={tab.title}
              isSelected={selectedTabIndex === index}
              onClick={() => handleTabSelection(index)}
            />
          ))}
      </TabContainerWrapper>
      {tabs &&
        tabs.map((tab, index) => (
          <>
            {selectedTabIndex === index && (
              <TabContainterContent key={`${tab.title}-${index}`}>
                {tab.content}
              </TabContainterContent>
            )}
          </>
        ))}
    </>
  );
}
